"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.Back=void 0;const Back=exports.Back="Back";